export default "__VITE_PUBLIC_ASSET__d160da55__"